/**
 * Відкриття backend-друкованих форм (HTMLResponse під JWT), 2026-08-28.
 *
 * window.open(url) на /api/v1/... давав 401 Not authenticated: токен живе
 * у памʼяті/localStorage, не у cookie — новий таб іде без Authorization.
 * Тому качаємо HTML авторизованим axios і відкриваємо як blob-вкладку
 * (друк з неї працює як зі звичайної сторінки).
 */
import { api } from '@/api/client';

export async function openPrintView(path: string): Promise<void> {
  // path — БЕЗ /api/v1 (api.baseURL додає його сам); зріжемо, якщо передали.
  const clean = path.startsWith('/api/v1') ? path.slice('/api/v1'.length) : path;
  try {
    const html = (await api.get<string>(clean, { responseType: 'text' })).data;
    const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    alert('Не вдалося відкрити друковану форму.');
  }
}
